import { FormSection } from '../../../../forms/FormSection'
import { VehicleForm } from '../forms/VehicleForm'

export const Vehicle = ({ number = 1 }: { number?: number }) => {
  return (
    <FormSection number={number} sectionTitle="Vozidlo">
      <VehicleForm />
    </FormSection>
  )
}